import { ActionType } from 'typesafe-actions';
import BaseReducer, {
baseInitialState,
} from '../../../../../boilerplate/redux/BaseReducer';
import { IBaseStateType } from '../../../../../boilerplate/redux/types/IBaseStateType';
import * as mostUsedQueriesActions from './mostUsedQueriesActions';

export type mostUsedQueriesAction = ActionType<typeof mostUsedQueriesActions>;

export interface ImostUsedQueriesStateType extends IBaseStateType {
	readonly entryMap: { [queryKey: string]: ITagType };
	readonly queries: { [queryKey: string]: ITagType[] };
}

export function mostUsedQueriesReducer(
	state = baseInitialState as ImostUsedQueriesStateType,
	action: mostUsedQueriesAction,
) {
	const Reducer = new BaseReducer('mostUsedQueriesReducer', 'slug');

	return Reducer.extend(state, action, (innerState, innerAction) => {
		switch (innerAction.type) {
			case 'OTHER_ACTION_TYPE':
				return Object.assign({}, innerState, {
					data: null,
					done: false,
					error: null,
					loading: true,
				});

			default:
				return innerState;
		}
	});
}
